import { render, staticRenderFns } from "./EditDocLabPCR.vue?vue&type=template&id=514152c5&scoped=true"
import script from "./EditDocLabPCR.vue?vue&type=script&lang=js"
export * from "./EditDocLabPCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514152c5",
  null
  
)

export default component.exports